import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AssociateAgentRoutes = defineRoute({
    record: {
        route: {
            path: "/associate-agent",
            component: () => loadView(import("./AssociateAgentTable.vue")),
        },
    },
    create: {
        route: {
            path: "/associate-agent/create",
            component: () => loadView(import("./AssociateAgentCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/associate-agent/update/:id",
            component: () => loadView(import("./AssociateAgentUpdate.vue")),
        },
        build(id: string) {
            return `/associate-agent/update/${id}`;
        },
    },
});
